import { handlePlatformEvent } from "../../../../helpers/GTM"

export const trackPromoBadgeImpression = ({ pageType, sku }) => {
  if (__BROWSER__) {
    if (!sku || !pageType) {
      return
    }

    handlePlatformEvent({
      event: 'view_promo_badge',
      pageType,
      sku,
    })
  }
}
